// extracted by mini-css-extract-plugin
export default {"root":"Faqs_root__bpB9c","control":"Faqs_control__WKUje","item":"Faqs_item__9pqSs","panel":"Faqs_panel__QqQnU","chevron":"Faqs_chevron__fzhCB"};